import { TradingProcedureStatusDto, TradingProcedureResponseDto, TradingProcedureTypeDto } from '@tradgine/data-access/tradgine-data';
import { TradingProcedure, TradingProcedureType } from '../../../../features/trading-procedure-list/domain/trading-procedure.model';
import { normalizeCurrency } from '../../../../core/constants/currency-map';

export function toTradingProcedure(tp: TradingProcedureResponseDto): TradingProcedure {
    const type = toType(tp.type);
    return {
        id: tp.id,
        type,
        showSellerName: tp.showSellerName,
        name: tp.name ?? '',
        sellerOrganizationName: tp.sellerOrganizationName,
        sellerOrganizationLogo: tp.sellerOrganizationLogo,
        sellerOrganizationTypeName: tp.sellerOrganizationTypeName,
        startDateTime: new Date(tp.startDateTime ?? ''),
        endDateTime: new Date(tp.endDateTime ?? ''),
        status: toStatus(tp.status),
        bidStepAmount: tp.bidStepAmount ?? 0,
        sellerDescription: tp.sellerDescription ?? '',
        currency: normalizeCurrency(tp.currency),
        createdDateTime: new Date(tp.createdDateTime ?? ''),

        lotCount: tp.lotCount,
        contractCount: tp.contractCount,
        debtAmount: tp.debtAmount,
        principalAmount: tp.principalAmount,
        averageDpd: tp.averageDpd,
        minPrice: tp.minPrice,
        currentPrice: tp.currentPrice,
    };
}

export function toStatus(status: TradingProcedureStatusDto): TradingProcedure['status'] {
    switch (status) {
        case TradingProcedureStatusDto.Draft: return 'draft';
        case TradingProcedureStatusDto.Active: return 'active';
        case TradingProcedureStatusDto.Published: return 'published';
        case TradingProcedureStatusDto.AwaitingDecision: return 'awaitingDecision';
        case TradingProcedureStatusDto.Finished: return 'finished';
        case TradingProcedureStatusDto.Cancelled: return 'cancelled';
    }
}

function toType(type: TradingProcedureTypeDto): TradingProcedureType {
    switch (type) {
        case TradingProcedureTypeDto.English:
            return TradingProcedureType.English;
        case TradingProcedureTypeDto.Sealed:
            return TradingProcedureType.Sealed;
        default:
            // Fallback for unexpected backend values to avoid crashes
            return TradingProcedureType.Unknown;
    }
}
